export default __webpack_public_path__ + "static/media/about-popup-bg.41bca44d.png";